import React from 'react';

const SvgMw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MW_svg__b" fill="#fff">
        <use xlinkHref="#MW_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MW_svg__a" />
      <path fill="#262626" mask="url(#MW_svg__b)" d="M0 0h28v6.667H0z" />
      <circle
        fill="#E42038"
        mask="url(#MW_svg__b)"
        cx={14}
        cy={7.333}
        r={4.667}
      />
      <path fill="#E42038" mask="url(#MW_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#47B849" mask="url(#MW_svg__b)" d="M0 13.333h28V20H0z" />
    </g>
  </svg>
);

export default SvgMw;
